import type { AuthDataResponse } from './auth.entity';

/**
 * Value Object que encapsula la validación de respuestas de autenticación
 * Centraliza la lógica de validación para evitar duplicación
 */
export class AuthResponseValueObject {
  private readonly response: AuthDataResponse;

  private constructor(response: AuthDataResponse) {
    this.response = response;
  }

  /**
   * Factory method que valida y crea una instancia de AuthResponseValueObject
   */
  static create(response: AuthDataResponse): AuthResponseValueObject {
    if (!response?.token || response.token.trim() === '')
      throw new Error('Invalid authentication response: El token esta vacío !');

    if (!response?.user)
      throw new Error(
        'Invalid authentication response: Datos de usuario vacío !',
      );

    return new AuthResponseValueObject(response);
  }

  /**
   * Retorna la respuesta validada
   */
  getValue(): AuthDataResponse {
    return this.response;
  }
}
